import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { TealiumAnalyticsEvent, TealiumAnalyticsService } from '@ddt-web/analytics';
import { ApplicationPathConstants, PortfolioEditorMode } from '@ddt-web/config';
import { SharedApplicationConstants } from '@ddt-web/domain';

import { ModelsBrowseLinkActionsService } from '../../services';


@Component({
	selector: 'mb-actions-drawer',
	templateUrl: './browsing-actions-drawer.component.html',
	styleUrls: ['./browsing-actions-drawer.component.scss']
})
export class BrowsingActionsDrawerComponent {
	@Input() public portfolioId: string;
	@Input() public category: string;
	@Input() public familyType: string;
	@Input() public familyId: string;

	public showMenu: boolean;

	constructor(
		private tealiumAnalyticsService: TealiumAnalyticsService,
		private elementRef: ElementRef,
		private modelsBrowseLinkActionsService: ModelsBrowseLinkActionsService
	) { }

	@HostListener('document:keydown.escape')
	public onKeydownHandler(): void {
		this.showMenu = false;
	}

	/**
	 * Checks if the menu is coming from outside the component and hides the option menu.
	 *
	 * @param {*} event
	 */
	@HostListener('document:click', ['$event'])
	public onClickOutsideTheComponent(event: any): void {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.showMenu = false;
		}
	}

	public onRedirectTo360(): void {
		this.tealiumAnalyticsService.trackEventTealium(
			new TealiumAnalyticsEvent(`actions-drawer:button:analyze:${this.familyType}:${this.category}:${this.familyId}:${this.portfolioId}`, {})
		);
		this.modelsBrowseLinkActionsService.redirectOnLinkAction(SharedApplicationConstants.PORTFOLIO_ANALYSER_PAGE, ApplicationPathConstants.PA_PATHS.OVERVIEW, this.portfolioId);
	}

	public onGenerateReportClick(): void {
		this.tealiumAnalyticsService.trackEventTealium(new TealiumAnalyticsEvent(`actions-drawer:button:generate:${this.portfolioId}`, {}));
		this.modelsBrowseLinkActionsService.redirectOnLinkAction(SharedApplicationConstants.PORTFOLIO_ANALYSER_PAGE, ApplicationPathConstants.PA_PATHS.GENERATE, this.portfolioId);

	}

	public onCustomizePortfolio(): void {
		this.tealiumAnalyticsService.trackEventTealium(
			new TealiumAnalyticsEvent(`actions-drawer:button:customize:${this.familyType}:${this.category}:${this.familyId}:${this.portfolioId}`, {})
		);
		this.modelsBrowseLinkActionsService.redirectOnLinkAction(SharedApplicationConstants.PORTFOLIO_ANALYSER_PAGE, ApplicationPathConstants.PA_PATHS.EDIT, this.portfolioId);
	}

	public onBlendPortfolio(): void {
		this.tealiumAnalyticsService.trackEventTealium(
			new TealiumAnalyticsEvent(`actions-drawer:button:blend:${this.familyType}:${this.category}:${this.familyId}:${this.portfolioId}`, {})
		);

		const path = ApplicationPathConstants.PORTFOLIO_EDITOR_PATH + '/' + ApplicationPathConstants.PORTFOLIO_EDITOR_PATHS.EDIT;

		this.modelsBrowseLinkActionsService.redirectOnLinkAction(SharedApplicationConstants.PORTFOLIO_ANALYSER_PAGE, path, this.portfolioId, PortfolioEditorMode.BLEND);
	}
}
